<template>

  <v-container fluid>
    <v-row class="text-center">
      <v-col>
        <InstrumentUltimateTzSalaryAdvance :customer="customer" :instrumentId="instrumentId" />
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-col class="text-h4 red--text">
        {{customer.name}} has an open loan and is ineligible for another Salary Advance loan.
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import InstrumentUltimateTzSalaryAdvance from "@/views/instruments/InstrumentUltimateTzSalaryAdvance"

export default {

  components: { InstrumentUltimateTzSalaryAdvance },

  props: ['customer', 'instrumentId'],

}
</script>
